module.exports = __webpack_public_path__ + "img/monetize-apis-subscription-model-thumbnail-tc.f9928944.jpg";